import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Collapse from "react-bootstrap/Collapse";
import logoinf from "./information.svg";

import { useEffect, useState, useRef } from "react";
import axios from "axios";
import Accordion from "react-bootstrap/Accordion";
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Image,
  Button,
} from "react-bootstrap";
import logo from "./logo1.png";
import logoNo from "./user.svg";
import "./App.css";
import MyGraph from "./MyGraph.js";
import logoCo from "./company.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function List1() {
  const [middleName, setMiddleName] = useState("");
  const [volocomScore, setVolocomScore] = useState("");
  const [legalScore, setLegalScore] = useState("");

  const [commonValueCR, setCommonValueCR] = useState("");
  const [commonDescriptionCR, setCommonDescriptionCR] = useState("");
  const [creditLimitCurrencyCR, setCreditLimitCurrencyCR] = useState("");
  const [creditLimitValCR, setCreditLimitValCR] = useState("");
  const [providerValMaxCR, ProviderValMaxCR] = useState("");
  const [providerValMinCR, ProviderValMinCR] = useState("");
  const [providerValCR, ProviderValCR] = useState("");
  const [providerDescCR, setProviderDescCR] = useState("");
  const [commonValueCCR, setCommonValueCCR] = useState("");
  const [commonDescriptionCCR, setCommonDescriptionCCR] = useState("");
  const [creditLimitCurrencyCCR, setCreditLimitCurrencyCCR] = useState("");
  const [creditLimitValCCR, setCreditLimitValCCR] = useState("");
  const [providerValMaxCCR, ProviderValMaxCCR] = useState("");
  const [providerValMinCCR, ProviderValMinCCR] = useState("");
  const [providerValCCR, ProviderValCCR] = useState("");
  const [providerDescCCR, setProviderDescCCR] = useState("");
  const [commonValuePCR, setCommonValuePCR] = useState("");
  const [commonDescriptionPCR, setCommonDescriptionPCR] = useState("");
  const [creditLimitCurrencyPCR, setCreditLimitCurrencyPCR] = useState("");
  const [creditLimitValPCR, setCreditLimitValPCR] = useState("");
  const [providerValMaxPCR, ProviderValMaxPCR] = useState("");
  const [providerValMinPCR, ProviderValMinPCR] = useState("");
  const [providerValPCR, ProviderValPCR] = useState("");
  const [providerDescPCR, setProviderDescPCR] = useState("");

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);

  const [popoverOpen2, setPopoverOpen2] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);

  const location = useLocation();
  const { PersonFromID } = location.state;

  const [articlesDict, setArticlesDict] = useState([]);

  const [linkedBusinessDict, setLinkedBusinessDict] = useState([]);
  const [companyData, setCompanyData] = useState([]);

  const [linkedPeopleDict, setLinkedPeopleDict] = useState([]);

  const [politicalPositions, setPoliticalPositions] = useState([]);

  //INFO (DOPO ATTENTE ANALISI MEGLIO FARLO A mano)
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [email, setEmail] = useState("");
  const [faxNumber, setFaxNumber] = useState("");
  const [forename, setForename] = useState("");
  const [fullName, setFullName] = useState("");
  const [gender, setGender] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [isAdverseMedia, setIsAdverseMedia] = useState(false);
  const [isDeceased, setIsDeceased] = useState(false);
  const [isDisqualifiedDirector, setIsDisqualifiedDirector] = useState(false);
  const [isFinancialregulator, setIsFinancialRegulator] = useState(false);
  const [isFinancialregulatorv, setIsFinancialRegulatorV] = useState(false);
  const [isInsolvent, setIsInsolvent] = useState(false);
  const [isLawEnforcement, setIsLawEnforcement] = useState(false);
  const [isPEP, setIsPEP] = useState(false);
  const [isSanctionsCurrent, setIsSanctionsCurrent] = useState(false);
  const [isSanctionsPrevious, setIsSanctionsPrevious] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [nationality, setNationality] = useState("");
  const [pepLevel, setPEPLevel] = useState(0);
  const [personId, setPersonId] = useState(0);
  const [surname, setSurname] = useState("");
  const [telephoneNumber, setTelephoneNumber] = useState("");
  const [yearOfBirth, setYearOfBirth] = useState(0);
  //FINE INFO A mano

  //INFO FIGLIO (DOPO ATTENTE ANALISI MEGLIO FARLO A mano)
  const [sondateOfBirth, setDateOfBirthson] = useState("");
  const [sonemail, setEmailson] = useState("");
  const [sonfaxNumber, setFaxNumberson] = useState("");
  const [sonforename, setForenameson] = useState("");
  const [sonfullName, setFullNameson] = useState("");
  const [songender, setGenderson] = useState("");
  const [sonimageURL, setImageURLson] = useState("");
  const [sonisAdverseMedia, setIsAdverseMediason] = useState(false);
  const [sonisDeceased, setIsDeceasedson] = useState(false);
  const [sonisDisqualifiedDirector, setIsDisqualifiedDirectorson] =
    useState(false);
  const [sonisFinancialregulator, setIsFinancialRegulatorson] = useState(false);
  const [sonisFinancialregulatorv, setIsFinancialRegulatorVson] =
    useState(false);
  const [sonisInsolvent, setIsInsolventson] = useState(false);
  const [sonisLawEnforcement, setIsLawEnforcementson] = useState(false);
  const [sonisPEP, setIsPEPson] = useState(false);
  const [sonisSanctionsCurrent, setIsSanctionsCurrentson] = useState(false);
  const [sonisSanctionsPrevious, setIsSanctionsPreviousson] = useState(false);
  const [sonmobileNumber, setMobileNumberson] = useState("");
  const [sonnationality, setNationalityson] = useState("");
  const [sonpepLevel, setPEPLevelson] = useState(0);
  const [sonpersonId, setPersonIdson] = useState(0);
  const [sonsurname, setSurnameson] = useState("");
  const [sontelephoneNumber, setTelephoneNumberson] = useState("");
  const [sonyearOfBirth, setYearOfBirthson] = useState(0);
  //FINE FIGLIO INFO A MANo
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose2 = () => setShow2(false);

  //Oggetti per il myGraph
  const [objNodes, setObjNodes] = useState([]);
  useEffect(() => {
    setObjNodes([
      {
        id: "0",
        idP: personId,
        label: fullName,
        size: 35,
        icon: imageURL,
      },
      {
        id: "1",
        label: "Link People",
        size: 20,
      },
      {
        id: "2",
        label: "Link Business",
        size: 20,
      },
      ...(linkedPeopleDict && linkedPeopleDict.length > 0
        ? linkedPeopleDict.slice(0, 5).map((item, index) => ({
            id: ((index + 3) * 1).toString(),
            label: item.fullName,
            icon: logoNo,
            size: 15,
            idP: item.personId,
          }))
        : []),
      ...(linkedBusinessDict && linkedBusinessDict.length > 0
        ? linkedBusinessDict.slice(0, 5).map((item, index) => ({
            id: (index + 8 * 1).toString(),
            label: item.businessName,
            icon: logoCo,
            size: 15,
          }))
        : []),
    ]);

    setFlag(true);

    // eslint-disable-next-line
  }, [linkedPeopleDict, linkedBusinessDict]);

  const handleReturn = () => {
    navigate("/", { replace: true });
  };

  // --- ALGORITMO MOSTRA INFO AZIENDA ---
  const handleShowLB = (businessId) => {
    setCommonValueCR("");
    setCommonDescriptionCR("");
    setCreditLimitCurrencyCR("");
    setCreditLimitValCR("");
    ProviderValMaxCR("");
    ProviderValMinCR("");
    ProviderValCR("");
    setProviderDescCR("");
    setCommonValueCCR("");
    setCommonDescriptionCCR("");
    setCreditLimitCurrencyCCR("");
    setCreditLimitValCCR("");
    ProviderValMaxCCR("");
    ProviderValMinCCR("");
    ProviderValCCR("");
    setProviderDescCCR("");
    setCommonValuePCR("");
    setCommonDescriptionPCR("");
    setCreditLimitCurrencyPCR("");
    setCreditLimitValPCR("");
    ProviderValMaxPCR("");
    ProviderValMinPCR("");
    ProviderValPCR("");
    setProviderDescPCR("");

    const selectedCompany = linkedBusinessDict.find(
      (item) => item.businessId === businessId
    );

    if (selectedCompany) {
      const companyData = [
        { key: "Nome Attività", value: selectedCompany.businessName },
        { key: "Indirizzo", value: selectedCompany.address },
        {
          key: "Capitale Dichiarato",
          value: selectedCompany.shareCapital.toLocaleString("it-IT", {
            style: "currency",
            currency: "EUR",
          }),
        },
        //id attività e id azienda fuori
        { key: "Numero Azienda", value: selectedCompany.companyNumber },
        {
          key: "Numero Registrazione Attività",
          value: selectedCompany.companyRegistrationNumber,
        },
        { key: "Paese", value: selectedCompany.country },
        { key: "Indirizzo Email", value: selectedCompany.emailAddresses },
        { key: "Eventi Cigs", value: selectedCompany.hasCigsEvents },
        {
          key: "Insolvenze Aziendali",
          value: selectedCompany.hasCompaniesInsolvency,
        },
        { key: "Insolvenze", value: selectedCompany.hasInsolvency },
        { key: "Pregiudizi", value: selectedCompany.hasPrejudicials },
        {
          key: "Pregiudizi Gravi",
          value: selectedCompany.hasSeverePrejudicials,
        },
        { key: "Proteste", value: selectedCompany.hasProtesti },
        { key: "Proteste Gravi", value: selectedCompany.hasSevereProtesti },
        { key: "HQType", value: selectedCompany.hqType },
        //incorporation data fuori
        {
          key: "Data dell'ultimo Rating effettuato",
          value: selectedCompany.latestRatingChangeDate,
        },
        // {
        //   key: "LatestShareholdersEquityFigure",
        //   value: selectedCompany.latestShareholdersEquityFigure,
        // },
        // {
        //   key: "LatestTurnoverFigure",
        //   value: selectedCompany.latestTurnoverFigure,
        // },
        // { key: "LatestUpdateOnIc", value: selectedCompany.latestUpdateOnIc },
        { key: "Forma Legale", value: selectedCompany.legalForm },
        { key: "Tipo Forma Legale", value: selectedCompany.legalFormType },
        {
          key: "Classificazione Attività Principale",
          value: selectedCompany.mainActivityClassification,
        },
        {
          key: "Codice Attività Principale",
          value: selectedCompany.mainActivityCode,
        },
        {
          key: "Descrizione Attività Principale",
          value: selectedCompany.mainActivityDescription,
        },
        { key: "Numero Dipendenti", value: selectedCompany.numberOfEmployees },
        { key: "Provincia", value: selectedCompany.province },
        {
          key: "Sezione Registro Pubblico",
          value: selectedCompany.publicRegisterSection,
        },
        { key: "Codice Rae", value: selectedCompany.raeCode },
        {
          key: "Iscrizione Rae",
          value: selectedCompany.reaInscriptionDate,
        },
        { key: "Stato Registrazione", value: selectedCompany.registerStatus },
        { key: "Codice Sae", value: selectedCompany.saeCode },
        { key: "Stato", value: selectedCompany.status },
        { key: "Stato Descrizione", value: selectedCompany.statusDescription },
        { key: "Codice Tax", value: selectedCompany.taxCode },
        { key: "Telephone", value: selectedCompany.telephone },
        {
          key: "Numero Registrazione Vat",
          value: selectedCompany.vatRegistrationNumber,
        },
      ];

      const jsonCR = selectedCompany.creditRating;
      const objCR = JSON.parse(jsonCR);

      setCommonValueCR(objCR.commonValue);
      setCommonDescriptionCR(objCR.commonDescription);

      if (objCR.creditLimit) {
        setCreditLimitCurrencyCR(objCR.creditLimit.currency);
        setCreditLimitValCR(objCR.creditLimit.value);
      }
      ProviderValMaxCR(objCR.providerValue.maxValue);
      ProviderValMinCR(objCR.providerValue.minValue);
      ProviderValCR(objCR.providerValue.value);
      setProviderDescCR(objCR.providerDescription);

      const jsonCCR = selectedCompany.currentCreditRating;
      const objCCR = JSON.parse(jsonCCR);

      setCommonValueCCR(objCCR.commonValue);
      setCommonDescriptionCCR(objCCR.commonDescription);

      if (objCCR.creditLimit) {
        setCreditLimitCurrencyCCR(objCCR.creditLimit.currency);
        setCreditLimitValCCR(objCCR.creditLimit.value);
      }
      ProviderValMaxCCR(objCCR.providerValue.maxValue);
      ProviderValMinCCR(objCCR.providerValue.minValue);
      ProviderValCCR(objCCR.providerValue.value);
      setProviderDescCCR(objCCR.providerDescription);

      const jsonPCR = selectedCompany.previousCreditRating;
      const objPCR = JSON.parse(jsonPCR);

      setCommonValuePCR(objPCR.commonValue);
      setCommonDescriptionPCR(objPCR.commonDescription);
      if (objPCR.creditLimit) {
        setCreditLimitCurrencyPCR(objPCR.creditLimit.currency);
        setCreditLimitValPCR(objPCR.creditLimit.value);
      }
      ProviderValMaxPCR(objPCR.providerValue.maxValue);
      ProviderValMinPCR(objPCR.providerValue.minValue);
      ProviderValPCR(objPCR.providerValue.value);
      setProviderDescPCR(objPCR.providerDescription);

      setCompanyData(companyData);
    }
    setShow(true);
  };

  // --- FINE ALGORITMO MOSTRA INFO AZIENDA ---

  // --- INIZIO ALGORITMO MOSTRA INFO PERSONA ---

  const handleChangeProfile = (personId) => {
    navigate("/List2", {
      replace: true,
      state: {
        PersonFromPersonId: personId,
        PersonFromID: PersonFromID,
        nomePrec: fullName,
        id: 1,
      },
    });
  };

  async function handleShowLP(personId) {
    setShow2(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_getPersonFromPersonID}?personId=${personId}`
      );

      setDateOfBirthson(response.data.Persona.dateOfBirth);
      setEmailson(response.data.Persona.email);
      setFaxNumberson(response.data.Persona.faxNumber);
      setForenameson(response.data.Persona.forename);
      setFullNameson(response.data.Persona.fullName);
      setGenderson(response.data.Persona.gender);
      setImageURLson(response.data.Persona.imageURL);
      setIsAdverseMediason(response.data.Persona.isAdverseMedia);
      setIsDeceasedson(response.data.Persona.isDeceased);
      setIsDisqualifiedDirectorson(
        response.data.Persona.isDisqualifiedDirector
      );
      setIsFinancialRegulatorson(response.data.Persona.isFinancialregulator);
      setIsFinancialRegulatorVson(response.data.Persona.isFinancialregulatorv);
      setIsInsolventson(response.data.Persona.isInsolvent);
      setIsLawEnforcementson(response.data.Persona.isLawEnforcement);
      setIsPEPson(response.data.Persona.isPEP);
      setIsSanctionsCurrentson(response.data.Persona.isSanctionsCurrent);
      setIsSanctionsPreviousson(response.data.Persona.isSanctionsPrevious);
      setMobileNumberson(response.data.Persona.mobileNumber);
      setNationalityson(response.data.Persona.nationality);
      setPEPLevelson(response.data.Persona.pepLevel);
      setPersonIdson(response.data.Persona.personId);
      setSurnameson(response.data.Persona.surname);
      setTelephoneNumberson(response.data.Persona.telephoneNumber);
      setYearOfBirthson(response.data.Persona.yearOfBirth);
    } catch (error) {
      console.error(error);
    }
  }

  // --- FINE ALGORITMO INFO PERSONA

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      getPersonFromID();
    }, 1000);
    // eslint-disable-next-line
  }, [PersonFromID]);

  useEffect(() => {
    retrieve_entities_per();
    // eslint-disable-next-line
  }, [fullName]);

  useEffect(() => {
    retrieve_entities_per_legal();
    // eslint-disable-next-line
  }, [fullName]);

  async function retrieve_entities_per_legal() {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_retrieve_entities}?entity_name=${fullName}%20${
          middleName ? middleName : ""
        }&entity_type=PER&table_name=volocom_score`
      );

      if (response.data.entity_name) {
        setVolocomScore(response.data.entity_score);
        //setVolocomScore(-0.7962500065937638);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function retrieve_entities_per() {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_retrieve_entities}?entity_name=${fullName}%20${
          middleName ? middleName : ""
        }&entity_type=PER&table_name=legal_score`
      );

      if (response.data.entity_name) {
        setLegalScore(response.data.entity_score);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function getPersonFromID() {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_getPersonFromID}?id=${PersonFromID}`
      );

      //CARICAMENTO ARTICOLI
      let articles = [];
      for (let i = 0; i < response.data.Persona.articles.length; i++) {
        articles.push(response.data.Persona.articles[i]);
      }
      setArticlesDict(articles);

      let businessObj = {};
      for (let i = 0; i < response.data.Persona.linkedBusiness.length; i++) {
        if (response.data.Persona.linkedBusiness[i].country) {
          let businessItem = response.data.Persona.linkedBusiness[i];
          businessObj[businessItem.businessId] = businessItem;
        }
      }
      let business = Object.values(businessObj);
      setLinkedBusinessDict(business);

      let personObj = {};
      for (let i = 0; i < response.data.Persona.linkedPeople.length; i++) {
        let businessItem = response.data.Persona.linkedPeople[i];
        personObj[businessItem.personId] = businessItem;
      }
      let people = Object.values(personObj);
      setLinkedPeopleDict(people);

      let politics = [];
      for (
        let i = 0;
        i < response.data.Persona.politicalPositions.length;
        i++
      ) {
        politics.push(response.data.Persona.politicalPositions[i]);
      }
      setPoliticalPositions(politics);

      //   let people = [];
      //   for (let i = 0; i < response.data.Persona.linkedPeople.length; i++) {
      //     people.push(response.data.Persona.linkedPeople[i]);
      //   }
      //   setLinkedPeopleDict(people);

      //CARICAMENTO DATI INFO
      setDateOfBirth(response.data.Persona.dateOfBirth);
      setEmail(response.data.Persona.email);
      setFaxNumber(response.data.Persona.faxNumber);
      setForename(response.data.Persona.forename);
      setFullName(response.data.Persona.fullName);
      setGender(response.data.Persona.gender);
      setImageURL(response.data.Persona.imageURL);
      setIsAdverseMedia(response.data.Persona.isAdverseMedia);
      setIsDeceased(response.data.Persona.isDeceased);
      setIsDisqualifiedDirector(response.data.Persona.isDisqualifiedDirector);
      setIsFinancialRegulator(response.data.Persona.isFinancialregulator);
      setIsFinancialRegulatorV(response.data.Persona.isFinancialregulatorv);
      setIsInsolvent(response.data.Persona.isInsolvent);
      setIsLawEnforcement(response.data.Persona.isLawEnforcement);
      setIsPEP(response.data.Persona.isPEP);
      setIsSanctionsCurrent(response.data.Persona.isSanctionsCurrent);
      setIsSanctionsPrevious(response.data.Persona.isSanctionsPrevious);
      setMobileNumber(response.data.Persona.mobileNumber);
      setNationality(response.data.Persona.nationality);
      setPEPLevel(response.data.Persona.pepLevel);
      setPersonId(response.data.Persona.personId);
      setSurname(response.data.Persona.surname);
      setTelephoneNumber(response.data.Persona.telephoneNumber);
      setYearOfBirth(response.data.Persona.yearOfBirth);
      setMiddleName(response.data.Persona.middlename);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <Container className="App">
        <Row
          style={{
            borderBottom: "1px solid #ccc",
          }}
        >
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
          </header>
          <Button
            onClick={handleReturn}
            className="bottonehome"
            style={{
              width: "5rem",
              borderBottom: "0",
              marginBottom: "0.1rem",
            }}
          >
            Indietro
          </Button>
        </Row>
        <Row>
          <Col
            md={6}
            style={{ display: "grid", margin: "auto" }}
            className="align-items-center justify-content-center"
          >
            {isLoading ? (
              <>
                <Skeleton variant="rectangular" width={275} height={40} />
                <Skeleton variant="rectangular" width={275} height={40} />
                <Skeleton variant="rectangular" width={275} height={40} />
              </>
            ) : (
              <>
                <h1 style={{ fontFamily: "roboto" }}>
                  {middleName} {fullName}
                </h1>
                <h6 style={{ fontFamily: "roboto" }}>
                  <b>Livello PEP</b>
                  <OverlayTrigger
                    className="pop"
                    trigger="click"
                    placement="bottom"
                    overlay={
                      <Popover className="pop">
                        <Popover.Header as="h3">
                          <strong>Livello PEP</strong>
                        </Popover.Header>
                        <Popover.Body>
                          <p>
                            I quattro livelli di PEP (Politically Exposed
                            Person) sono :
                            <ol>
                              <li>
                                <a
                                  onClick={() => setOpen(!open)}
                                  aria-controls="example-collapse-text"
                                  aria-expanded={open}
                                >
                                  <p style={{ textDecoration: "underline" }}>
                                    PEP di Livello 1
                                  </p>
                                </a>
                                <Collapse in={open}>
                                  <div id="example-collapse-text">
                                    <p>
                                      Si riferisce a individui che occupano
                                      posizioni politiche di alto rango, come
                                      capi di stato, ministri, membri di
                                      parlamenti nazionali o funzionari
                                      governativi di alto livello.
                                    </p>
                                  </div>
                                </Collapse>
                              </li>
                              <li>
                                <a
                                  onClick={() => setOpen1(!open1)}
                                  aria-controls="example-collapse-text"
                                  aria-expanded={open1}
                                >
                                  <p style={{ textDecoration: "underline" }}>
                                    PEP di Livello 2
                                  </p>
                                </a>
                                <Collapse in={open1}>
                                  <div id="example-collapse-text">
                                    <p>
                                      Comprende persone associate a cariche
                                      politiche meno rilevanti rispetto al
                                      livello 1, come funzionari di partiti
                                      politici, membri di organizzazioni
                                      internazionali o candidati a posizioni
                                      politiche.
                                    </p>
                                  </div>
                                </Collapse>
                              </li>{" "}
                              <li>
                                <a
                                  onClick={() => setOpen2(!open2)}
                                  aria-controls="example-collapse-text"
                                  aria-expanded={open2}
                                >
                                  <p style={{ textDecoration: "underline" }}>
                                    PEP di Livello 3
                                  </p>
                                </a>
                                <Collapse in={open2}>
                                  <div id="example-collapse-text">
                                    <p>
                                      Include individui associati a posizioni
                                      politiche locali o regionali, come
                                      consiglieri comunali o membri di assemblee
                                      regionali.
                                    </p>
                                  </div>
                                </Collapse>
                              </li>{" "}
                              <li>
                                <a
                                  onClick={() => setOpen3(!open3)}
                                  aria-controls="example-collapse-text"
                                  aria-expanded={open3}
                                >
                                  <p style={{ textDecoration: "underline" }}>
                                    PEP di Livello 4
                                  </p>
                                </a>
                                <Collapse in={open3}>
                                  <div id="example-collapse-text">
                                    <p>
                                      Coinvolge persone collegate a
                                      organizzazioni politiche o entità
                                      commerciali associate a politici o partiti
                                      politici, ma che non ricadono nelle
                                      categorie precedenti.
                                    </p>
                                  </div>
                                </Collapse>
                              </li>
                            </ol>
                          </p>
                        </Popover.Body>
                      </Popover>
                    }
                    rootClose
                    onHide={() => setPopoverOpen(null)}
                  >
                    <img style={{ width: "1rem" }} src={logoinf}></img>
                  </OverlayTrigger>
                  <b> : {pepLevel ? pepLevel : "0"}</b>
                </h6>
                <h6 style={{ fontFamily: "roboto" }}>
                  <b>Expleo Media Exposure</b>
                  <OverlayTrigger
                    className="pop"
                    trigger="click"
                    placement="bottom"
                    overlay={
                      <Popover className="pop">
                        <Popover.Header as="h3">
                          <strong>Expleo Media Exposure</strong>
                        </Popover.Header>
                        <Popover.Body>
                          <p>
                            Punteggio assegnato dal modello di Sentiment
                            Analisys a partire dagli articoli in cui è presente
                            l'entita (valore compreso tra -1 e 1)
                          </p>
                        </Popover.Body>
                      </Popover>
                    }
                    rootClose
                    onHide={() => setPopoverOpen(null)}
                  >
                    <img style={{ width: "1rem" }} src={logoinf}></img>
                  </OverlayTrigger>{" "}
                  :{" "}
                  {volocomScore === "" ? (
                    <b>N/D</b>
                  ) : volocomScore < 0 ? (
                    <b style={{ color: "red" }}>
                      -{Math.abs(volocomScore.toFixed(2))}
                    </b>
                  ) : (
                    <b style={{ color: "green" }}>{volocomScore.toFixed(2)}</b>
                  )}
                </h6>
                <h6 style={{ fontFamily: "roboto" }}>
                  <b>Expleo Legal Exposure</b>
                  <OverlayTrigger
                    className="pop"
                    trigger="click"
                    placement="bottom"
                    overlay={
                      <Popover className="pop">
                        <Popover.Header as="h3">
                          <strong>Expleo Legal Exposure</strong>
                        </Popover.Header>
                        <Popover.Body>
                          <p>
                            Punteggio assegnato a partire dagli esiti delle
                            sentenze in cui è presente l'entita (valore compreso
                            tra -1 e 1)
                          </p>
                        </Popover.Body>
                      </Popover>
                    }
                    rootClose
                    onHide={() => setPopoverOpen(null)}
                  >
                    <img style={{ width: "1rem" }} src={logoinf}></img>
                  </OverlayTrigger>
                  {/* legalScore */}
                  <b>
                    {" "}
                    :{" "}
                    {legalScore === "" ? (
                      <b>N/D</b>
                    ) : legalScore < 0 ? (
                      <b style={{ color: "red" }}>
                        -{Math.abs(legalScore.toFixed(2))}
                      </b>
                    ) : (
                      <b style={{ color: "green" }}>{legalScore.toFixed(2)}</b>
                    )}
                  </b>
                </h6>
              </>
            )}
          </Col>
          <Col md={6}>
            {isLoading ? (
              <Skeleton variant="rectangular" width={101} height={120} />
            ) : (
              <Image
                style={{ width: "35%" }}
                src={imageURL ? imageURL : logoNo}
                alt="171x180"
                thumbnail
                responsive
              />
            )}
          </Col>
        </Row>
        <Row style={{ marginBottom: "5rem" }}>
          <Accordion>
            <Row>
              <Accordion.Item eventKey="0">
                <Accordion.Header>Info</Accordion.Header>
                <Accordion.Body>
                  <Row>
                    <Row xs={1} md={2}>
                      <Col>
                        <hr></hr>

                        <ul>
                          <li>
                            <b>Nome :</b> {forename ? forename : '""'}{" "}
                            {middleName ? middleName : ""}
                          </li>
                          <li>
                            <b>Cognome : </b> {surname ? surname : '""'}
                          </li>
                          <li>
                            <b>Data di nascità :</b>{" "}
                            {dateOfBirth ? dateOfBirth : '""'}
                          </li>
                          <li>
                            <b>Sesso :</b> {gender ? gender : '""'}
                          </li>
                          <li>
                            <b>Nazionalità : </b>{" "}
                            {nationality ? nationality : '""'}
                          </li>
                        </ul>
                      </Col>
                      <Col>
                        <hr></hr>
                        <ul>
                          <li>
                            <OverlayTrigger
                              className="pop"
                              trigger="click"
                              placement="bottom"
                              overlay={
                                <Popover className="pop">
                                  <Popover.Header as="h3">
                                    <strong>Notizie Negative</strong>
                                  </Popover.Header>
                                  <Popover.Body>
                                    <p>
                                      Il profilo corrispondente appartiene al
                                      set di dati "Adverse Media" di CreditSafe.
                                    </p>
                                  </Popover.Body>
                                </Popover>
                              }
                              rootClose
                              onHide={() => setPopoverOpen(null)}
                            >
                              <img
                                style={{ width: "1rem" }}
                                src={logoinf}
                              ></img>
                            </OverlayTrigger>
                            <b>Notizie negative : </b>
                            {isAdverseMedia ? "true" : "false"}
                          </li>
                          <li>
                            <b>Deceduto : </b> {isDeceased ? "true" : "false"}
                          </li>
                          <li>
                            <OverlayTrigger
                              className="pop"
                              trigger="click"
                              placement="bottom"
                              overlay={
                                <Popover className="pop">
                                  <Popover.Header as="h3">
                                    <strong>Squalificato dal Ruolo</strong>
                                  </Popover.Header>
                                  <Popover.Body>
                                    <p>
                                      Il profilo corrispondente appartiene al
                                      set di dati "Disqualified Director" di
                                      CreditSafe.
                                    </p>
                                  </Popover.Body>
                                </Popover>
                              }
                              rootClose
                              onHide={() => setPopoverOpen(null)}
                            >
                              <img
                                style={{ width: "1rem" }}
                                src={logoinf}
                              ></img>
                            </OverlayTrigger>
                            <b>Squalificato dal Ruolo : </b>
                            {isDisqualifiedDirector ? "true" : "false"}
                          </li>
                          <li>
                            <OverlayTrigger
                              className="pop"
                              trigger="click"
                              placement="bottom"
                              overlay={
                                <Popover className="pop">
                                  <Popover.Header as="h3">
                                    <strong>Regolatore Finanziario</strong>
                                  </Popover.Header>
                                  <Popover.Body>
                                    <p>
                                      Il profilo corrispondente appartiene al
                                      set di dati "Financial Regulator" di
                                      CreditSafe.
                                    </p>
                                  </Popover.Body>
                                </Popover>
                              }
                              rootClose
                              onHide={() => setPopoverOpen(null)}
                            >
                              <img
                                style={{ width: "1rem" }}
                                src={logoinf}
                              ></img>
                            </OverlayTrigger>
                            <b>Regolatore Finanziario : </b>{" "}
                            {isFinancialregulator ? "true" : "false"}
                          </li>
                          <li>
                            <OverlayTrigger
                              className="pop"
                              trigger="click"
                              placement="bottom"
                              overlay={
                                <Popover className="pop">
                                  <Popover.Header as="h3">
                                    <strong>Insolvente</strong>
                                  </Popover.Header>
                                  <Popover.Body>
                                    <p>
                                      Il profilo corrispondente appartiene al
                                      set di dati "Insolvency" di CreditSafe.
                                    </p>
                                  </Popover.Body>
                                </Popover>
                              }
                              rootClose
                              onHide={() => setPopoverOpen(null)}
                            >
                              <img
                                style={{ width: "1rem" }}
                                src={logoinf}
                              ></img>
                            </OverlayTrigger>
                            <b>Insolvente : </b>
                            {isInsolvent ? "true" : "false"}
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <Row xs={1} md={2}>
                      <Col>
                        <hr></hr>

                        <ul>
                          <li>
                            <OverlayTrigger
                              className="pop"
                              trigger="click"
                              placement="bottom"
                              overlay={
                                <Popover className="pop">
                                  <Popover.Header as="h3">
                                    <strong>
                                      Associato a Forze dell'Ordine
                                    </strong>
                                  </Popover.Header>
                                  <Popover.Body>
                                    <p>
                                      Il profilo corrispondente appartiene al
                                      set di dati "Law Enforcement" di
                                      CreditSafe.
                                    </p>
                                  </Popover.Body>
                                </Popover>
                              }
                              rootClose
                              onHide={() => setPopoverOpen(null)}
                            >
                              <img
                                style={{ width: "1rem" }}
                                src={logoinf}
                              ></img>
                            </OverlayTrigger>
                            <b>Associato a Forze dell'Ordine : </b>
                            {isLawEnforcement ? "true" : "false"}
                          </li>
                          <li>
                            <OverlayTrigger
                              className="pop"
                              trigger="click"
                              placement="bottom"
                              overlay={
                                <Popover className="pop">
                                  <Popover.Header as="h3">
                                    <strong>PEP</strong>
                                  </Popover.Header>
                                  <Popover.Body>
                                    <p>
                                      PEP (Politically Exposed Person) si
                                      riferisce a persone che occupano posizioni
                                      politiche di rilievo o sono associate a
                                      tali posizioni, come capi di stato,
                                      ministri, funzionari governativi di alto
                                      livello o membri di organizzazioni
                                      internazionali.
                                    </p>
                                  </Popover.Body>
                                </Popover>
                              }
                              rootClose
                              onHide={() => setPopoverOpen(null)}
                            >
                              <img
                                style={{ width: "1rem" }}
                                src={logoinf}
                              ></img>
                            </OverlayTrigger>
                            <b>PEP : </b> {isPEP ? "true" : "false"}
                          </li>
                          <li>
                            <b>Attualmente Sanzionato : </b>
                            {isSanctionsCurrent ? "true" : "false"}
                          </li>
                          <li>
                            <b>Precedentemente Sanzionato : </b>
                            {isSanctionsPrevious ? "true" : "false"}
                          </li>
                          <li>
                            <b>Numero Cellulare : </b>
                            {mobileNumber ? mobileNumber : '""'}
                          </li>
                        </ul>
                      </Col>

                      <Col>
                        <hr></hr>

                        <ul>
                          <li>
                            <b>Livello PEP : </b> {pepLevel ? pepLevel : '""'}
                          </li>

                          <li>
                            <b>Numero Fisso : </b>{" "}
                            {telephoneNumber ? telephoneNumber : '""'}
                          </li>
                          <li>
                            <b>Indirizzo email :</b> {email ? email : '""'}
                          </li>
                          <li>
                            <b>Numero Fax :</b> {faxNumber ? faxNumber : '""'}
                          </li>
                        </ul>
                      </Col>
                    </Row>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Row>
            <Row>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Articles ({articlesDict.length})
                </Accordion.Header>
                <Accordion.Body>
                  {articlesDict
                    .sort(
                      (a, b) =>
                        new Date(b.dateCollected) - new Date(a.dateCollected)
                    )
                    .map((item, index) => (
                      <Accordion key={index}>
                        <Accordion.Item eventKey={String(index)}>
                          <Accordion.Header>
                            {item.title === "" ? `Title #${index}` : item.title}{" "}
                            --- {item.dateCollected}
                          </Accordion.Header>
                          <Accordion.Body>
                            <Row style={{ border: "1px solid #ccc" }}>
                              <h6>{item.dateCollected}</h6>
                            </Row>
                            <Row style={{ border: "1px solid #ccc" }}>
                              <a href={item.originalURL}>link</a>
                            </Row>
                            <Row style={{ border: "1px solid #ccc" }}>
                              <p>{item.summary}</p>
                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    ))}
                </Accordion.Body>
              </Accordion.Item>
            </Row>
            <Row>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  Linked Business ({linkedBusinessDict.length})
                </Accordion.Header>
                <Accordion.Body>
                  <ListGroup style={{ textAlign: "initial" }}>
                    {linkedBusinessDict.map((item, index) => (
                      <ListGroupItem
                        style={{ cursor: "pointer" }}
                        onClick={() => handleShowLB(item.businessId)}
                        key={index}
                      >
                        {item.businessName}
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Row>
            <Row>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  Linked People ({linkedPeopleDict.length})
                </Accordion.Header>
                <Accordion.Body>
                  <ListGroup style={{ textAlign: "initial" }}>
                    {linkedPeopleDict
                      .sort((a, b) => {
                        // Ordinamento per presenza/assenza di yearOfBirth
                        if (a.yearOfBirth && !b.yearOfBirth) {
                          return -1; // a viene prima di b
                        } else if (!a.yearOfBirth && b.yearOfBirth) {
                          return 1; // b viene prima di a
                        } else {
                          // Ordinamento in base all'anno di nascita
                          return a.yearOfBirth - b.yearOfBirth;
                        }
                      })
                      .map((item, index) => (
                        <ListGroupItem
                          onClick={() => handleShowLP(item.personId)}
                          key={index}
                        >
                          {item.fullName}{" "}
                          {item.dateOfBirth ? "--- " + item.dateOfBirth : ""}
                        </ListGroupItem>
                      ))}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Row>
            <Row>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  Political Positions ({politicalPositions.length})
                </Accordion.Header>
                <Accordion.Body>
                  <ListGroup style={{ textAlign: "initial" }}>
                    {politicalPositions.map((item, index) => (
                      <ListGroupItem key={index}>
                        {item.country} --- ({item.description})
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Row>
            <Row>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Network Graph</Accordion.Header>
                <Accordion.Body>
                  <Row
                    style={{ marginTop: "5rem", marginBottom: "5rem" }}
                    hidden={false}
                    className="myrow"
                  >
                    {flag > 0 && (
                      <MyGraph
                        listPeople={linkedPeopleDict}
                        listCompany={linkedBusinessDict}
                        nodes={objNodes}
                      />
                    )}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Row>
          </Accordion>
        </Row>
      </Container>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Info Linked Business</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {companyData.map((item, index) => (
            <Table responsive striped bordered hover key={index}>
              <thead>
                <tr>
                  <th>{item.key}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {item.value === false
                      ? "false"
                      : item.value === true
                      ? "true"
                      : item.value}
                  </td>
                </tr>
              </tbody>
            </Table>
          ))}
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>
                  Credit Rating
                  <OverlayTrigger
                    className="pop"
                    trigger="click"
                    placement="bottom"
                    overlay={
                      <Popover className="pop">
                        <Popover.Header as="h3">
                          <strong>Credit Rating</strong>
                        </Popover.Header>
                        <Popover.Body>
                          <p>
                            Evidenza del limite di credito e dello score
                            associati all'azienda.
                          </p>
                        </Popover.Body>
                      </Popover>
                    }
                    rootClose
                    onHide={() => setPopoverOpen(null)}
                  >
                    <img style={{ width: "1rem" }} src={logoinf}></img>
                  </OverlayTrigger>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <ul>
                    <li>
                      Valutazione Generale :{" "}
                      <b>{commonValueCR ? commonValueCR : ""}</b>
                    </li>
                    <li>
                      Descrizione Generale :{" "}
                      <b>{commonDescriptionCR ? commonDescriptionCR : ""}</b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Limite di Credito</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Indica l'importo massimo di credito raccomandato
                                che dovrebbe essere concesso a un'azienda in un
                                determinato momento. Questo valore viene
                                calcolato prendendo in considerazione la
                                valutazione del rischio e le principali cifre
                                presenti nel bilancio delle aziende che
                                presentano i loro conti. Nel caso delle aziende
                                che non presentano i loro conti, il valore viene
                                stimato utilizzando altre informazioni non
                                finanziarie.
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Limite di Credito :{" "}
                      <b>{creditLimitValCR ? creditLimitValCR : ""}</b>
                    </li>
                    <li>
                      Valuta del Credito :{" "}
                      <b>
                        {creditLimitCurrencyCR ? creditLimitCurrencyCR : ""}
                      </b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Esito Valore CreditSafe</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Rappresenta il valore assegnato da Creditsafe
                                all'azienda in base alla loro valutazione del
                                rischio.
                                <ul>
                                  <li>{"<71-100> Very Low Risk"}</li>
                                  <li>{"<51-70>  Low Risk"}</li>
                                  <li>{"<30-50>  Moderate Risk"}</li>
                                  <li>{"<21-29>  High Risk"}</li>
                                  <li>{"<1-20>   Very High Risk"}</li>
                                </ul>
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Esito Valore CreditSafe :{" "}
                      <b>{providerValCR ? providerValCR : ""}</b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Esito CreditSafe</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Indica come Creditsafe ha classificato l'azienda
                                sulla base della loro valutazione.
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Esito CreditSafe :{" "}
                      <b>{providerDescCR ? providerDescCR : ""}</b>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </Table>
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>
                  Credit Rating Corrente
                  <OverlayTrigger
                    className="pop"
                    trigger="click"
                    placement="bottom"
                    overlay={
                      <Popover className="pop">
                        <Popover.Header as="h3">
                          <strong>Credit Rating Corrente</strong>
                        </Popover.Header>
                        <Popover.Body>
                          <p>
                            Evidenza del limite di credito e dello score
                            associati all'azienda attualmente.
                          </p>
                        </Popover.Body>
                      </Popover>
                    }
                    rootClose
                    onHide={() => setPopoverOpen(null)}
                  >
                    <img style={{ width: "1rem" }} src={logoinf}></img>
                  </OverlayTrigger>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <ul>
                    <li>
                      Valutazione Generale :{" "}
                      <b>{commonValueCCR ? commonValueCCR : ""}</b>
                    </li>
                    <li>
                      Descrizione Generale :{" "}
                      <b>{commonDescriptionCCR ? commonDescriptionCCR : ""}</b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Limite di Credito</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Indica l'importo massimo di credito raccomandato
                                che dovrebbe essere concesso a un'azienda in un
                                determinato momento. Questo valore viene
                                calcolato prendendo in considerazione la
                                valutazione del rischio e le principali cifre
                                presenti nel bilancio delle aziende che
                                presentano i loro conti. Nel caso delle aziende
                                che non presentano i loro conti, il valore viene
                                stimato utilizzando altre informazioni non
                                finanziarie.
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Limite di Credito :{" "}
                      <b>{creditLimitValCCR ? creditLimitValCCR : ""}</b>
                    </li>
                    <li>
                      Valuta del Credito :{" "}
                      <b>
                        {creditLimitCurrencyCCR ? creditLimitCurrencyCCR : ""}
                      </b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Esito Valore CreditSafe</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Rappresenta il valore assegnato da Creditsafe
                                all'azienda in base alla loro valutazione del
                                rischio.
                                <ul>
                                  <li>{"<71-100> Very Low Risk"}</li>
                                  <li>{"<51-70>  Low Risk"}</li>
                                  <li>{"<30-50>  Moderate Risk"}</li>
                                  <li>{"<21-29>  High Risk"}</li>
                                  <li>{"<1-20>   Very High Risk"}</li>
                                </ul>
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Esito Valore CreditSafe :{" "}
                      <b>{providerValCCR ? providerValCCR : ""}</b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Esito CreditSafe</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Indica come Creditsafe ha classificato l'azienda
                                sulla base della loro valutazione.
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Esito CreditSafe :{" "}
                      <b>{providerDescCCR ? providerDescCCR : ""}</b>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </Table>
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>
                  Credit Rating Precedente
                  <OverlayTrigger
                    className="pop"
                    trigger="click"
                    placement="bottom"
                    overlay={
                      <Popover className="pop">
                        <Popover.Header as="h3">
                          <strong>Credit Rating Precedente</strong>
                        </Popover.Header>
                        <Popover.Body>
                          <p>
                            Evidenza del limite di credito e dello score
                            associati all'azienda nella precedente analisi.
                          </p>
                        </Popover.Body>
                      </Popover>
                    }
                    rootClose
                    onHide={() => setPopoverOpen(null)}
                  >
                    <img style={{ width: "1rem" }} src={logoinf}></img>
                  </OverlayTrigger>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <ul>
                    <li>
                      Valutazione Generale :{" "}
                      <b>{commonValuePCR ? commonValuePCR : ""}</b>
                    </li>
                    <li>
                      Descrizione Generale :{" "}
                      <b>{commonDescriptionPCR ? commonDescriptionPCR : ""}</b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Limite di Credito</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Indica l'importo massimo di credito raccomandato
                                che dovrebbe essere concesso a un'azienda in un
                                determinato momento. Questo valore viene
                                calcolato prendendo in considerazione la
                                valutazione del rischio e le principali cifre
                                presenti nel bilancio delle aziende che
                                presentano i loro conti. Nel caso delle aziende
                                che non presentano i loro conti, il valore viene
                                stimato utilizzando altre informazioni non
                                finanziarie.
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Limite di Credito :{" "}
                      <b>{creditLimitValPCR ? creditLimitValPCR : ""}</b>
                    </li>
                    <li>
                      Valuta del Credito :{" "}
                      <b>
                        {creditLimitCurrencyPCR ? creditLimitCurrencyPCR : ""}
                      </b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Esito Valore CreditSafe</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Rappresenta il valore assegnato da Creditsafe
                                all'azienda in base alla loro valutazione del
                                rischio.
                                <ul>
                                  <li>{"<71-100> Very Low Risk"}</li>
                                  <li>{"<51-70>  Low Risk"}</li>
                                  <li>{"<30-50>  Moderate Risk"}</li>
                                  <li>{"<21-29>  High Risk"}</li>
                                  <li>{"<1-20>   Very High Risk"}</li>
                                </ul>
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Esito Valore CreditSafe :{" "}
                      <b>{providerValPCR ? providerValPCR : ""}</b>
                    </li>
                    <li>
                      <OverlayTrigger
                        className="pop"
                        trigger="click"
                        placement="bottom"
                        overlay={
                          <Popover className="pop">
                            <Popover.Header as="h3">
                              <strong>Esito CreditSafe</strong>
                            </Popover.Header>
                            <Popover.Body>
                              <p>
                                Indica come Creditsafe ha classificato l'azienda
                                sulla base della loro valutazione.
                              </p>
                            </Popover.Body>
                          </Popover>
                        }
                        rootClose
                        onHide={() => setPopoverOpen(null)}
                      >
                        <img style={{ width: "1rem" }} src={logoinf}></img>
                      </OverlayTrigger>
                      Esito CreditSafe :{" "}
                      <b>{providerDescPCR ? providerDescPCR : ""}</b>
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <button variant="secondary" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show2}
        onHide={handleClose2}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Info Persona</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image
            style={{ width: "30%" }}
            src={sonimageURL ? sonimageURL : logoNo}
            alt="171x180"
            thumbnail
            responsive
          />
          <Button onClick={() => handleChangeProfile(sonpersonId)}>
            Vai al Profilo
          </Button>
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Cognome</th>
                <th>Data di Nascità</th>
                <th>Sesso</th>
                <th>Nazionalità</th>
                <th>Notizie Negative</th>
                <th>Deceduto</th>
                <th>Squalificato dal Ruolo</th>
                <th>Regolatore Finanziario</th>
                <th>Insolvente</th>
                <th>Associato a Forze dell'Ordine</th>
                <th>PEP</th>
                <th>Attualmente Sanzionato</th>
                <th>Precedentemente Sanzionato</th>
                <th>Numero Cellulare</th>
                <th>Livello PEP</th>
                <th>Numero Fisso</th>
                <th>Email</th>
                <th>Numero Fax</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{sonforename}</td>
                <td>{sonsurname}</td>
                <td>{sondateOfBirth}</td>
                <td>{songender}</td>
                <td>{sonnationality}</td>

                <td>{sonisAdverseMedia ? "true" : "false"}</td>
                <td>{sonisDeceased ? "true" : "false"}</td>
                <td>{sonisDisqualifiedDirector ? "true" : "false"}</td>
                <td>{sonisFinancialregulator ? "true" : "false"}</td>
                <td>{sonisInsolvent ? "true" : "false"}</td>

                <td>{sonisLawEnforcement ? "true" : "false"}</td>
                <td>{sonisPEP ? "true" : "false"}</td>
                <td>{sonisSanctionsCurrent ? "true" : "false"}</td>
                <td>{sonisSanctionsPrevious ? "true" : "false"}</td>
                <td>{sonmobileNumber}</td>

                <td>{sonpepLevel}</td>

                <td>{sontelephoneNumber}</td>
                <td>{sonemail}</td>
                <td>{sonfaxNumber}</td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <button variant="secondary" onClick={handleClose2}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
